import React from "react";
import { Atom } from "react-loading-indicators";

const LoadingScreen = () => {
  return (
    <div style={styles.overlay}>
      <Atom color="#4fa94d" size="large" text="" />
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.7)", // slight opacity
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999, // Make sure it stays on top
  },
};

export default LoadingScreen;
